import { render, staticRenderFns } from "./PaxelMarket.vue?vue&type=template&id=4a872a5e&"
import script from "./PaxelMarket.vue?vue&type=script&lang=js&"
export * from "./PaxelMarket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports